import Controller from "./fulfillmentPlans.controller";
import template from "./fulfillmentPlans.html";

const fulfillmentPlans = {
  template,
  controller: Controller,
};

export default fulfillmentPlans;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlans/fulfillmentPlans.component.js